import api from 'app/api';

import getAll from './get-cities';

export const citiesApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getCities: getAll(builder),
    }),
});

export const { useGetCitiesQuery } = citiesApi;
